import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-register-email',
  templateUrl: './register-email.component.html',
  styleUrls: ['./register-email.component.scss']
})
export class RegisterEmailComponent {
  @Output() submitEmailEvent = new EventEmitter<string>();
  
  public emailForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    confirmEmail: ['', [Validators.required, Validators.email]]
  })
  
  constructor(private fb: FormBuilder) {}

  public doEmailsMatch() {
    const email = this.emailForm.get('email')?.value;
    const confirmEmail = this.emailForm.get('confirmEmail')?.value;
    if (!email || !confirmEmail) return false;
    return email === confirmEmail ? true : false;
  }

  public emailFieldsAreEmpty() {
    const email = this.emailForm.get('email')?.value;
    const confirmEmail = this.emailForm.get('confirmEmail')?.value;
    return email === '' || confirmEmail === '' ? true : false;
  }

  public submitEmailForm() {
    const email = this.emailForm.value.email?.trim()
    this.submitEmailEvent.emit(email);
  }

  public resetEmailForm(): void {
    this.emailForm.reset();
  }
}
